


    <!-- boton 'cerrar y guardar' alineado a la derecha -->
    <!-- <div style="text-align: right;">
        <button mat-raised-button (click)="cerraryguardar()">Guardar y Cerrar</button>
      </div> -->

<div style="margin-top: 10px; font-size: 12px; font-weight: bold; background-color: #f4f4f4; font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;  color:#5ac8fa ; height: 40px;">

    Campo Identificador: <input style="font-size: 12px; font-weight: bold; font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; height: 25px; color: #676a6C;" [(ngModel)]="campoidentificador" /> 
    Campo Descripcion: <input style="font-size: 12px; font-weight: bold; font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; height: 25px; color: #676a6C;" [(ngModel)]="campodescripcion" /> 
    </div>

<div id="surveyCreatorContainer"></div>